import type {
  IAccessReport,
  ICompanyValueReport,
  IDashboardSummary,
  IEmployeeInteractingByDepartmentsReport,
  IMobileSignedReport,
  IMostInteractiveEmployeeReport,
  IPortalLoginReportResponse,
  IPostTypeReport,
  ITemporalChangeReport,
} from '@/types/Data'
import type {
  IDateRange,
  IGetAccessReport,
  IGetCompanyValueReport,
  IGetDashboardSummary,
  IGetEmployeeInteractingByDepartmentsReport,
  IGetMobileSignedInUsers,
  IGetMostInteractiveEmployeeReport,
  IGetPortalLoginReport,
  IGetPostTypeReport,
  IGetTemporalChangeReport,
  IGetTemporalChangeReportExcel,
} from '@/types/Request'
import BaseService from '../BaseService'

export default class DashboardServices extends BaseService {
  GetMostInteractiveEmployeeReport(payload: IGetMostInteractiveEmployeeReport) {
    return this.POST<IMostInteractiveEmployeeReport[]>(
      this.PATHS.GET_MOST_INTERACTIVE_EMPLOYEE_REPORT,
      payload,
    )
  }

  GetEmployeesInteractingByDepartmentsReport(payload: IGetEmployeeInteractingByDepartmentsReport) {
    return this.POST<IEmployeeInteractingByDepartmentsReport[]>(
      this.PATHS.GET_EMPLOYEES_INTERACTING_BY_DEPARTMENTS_REPORT,
      payload,
    )
  }

  GetCompanyValueReport(payload: IGetCompanyValueReport) {
    return this.POST<ICompanyValueReport[]>(this.PATHS.GET_COMPANY_VALUE_REPORT, payload)
  }

  GetPostTypeReport(payload: IGetPostTypeReport) {
    return this.POST<IPostTypeReport[]>(this.PATHS.GET_POST_TYPE_REPORT, payload)
  }

  GetPortalLoginReport(payload: IGetPortalLoginReport) {
    return this.POST<IPortalLoginReportResponse>(this.PATHS.GET_PORTAL_LOGIN_REPORT, payload)
  }

  GetAccessReport(payload: IGetAccessReport) {
    return this.POST<IAccessReport>(this.PATHS.GET_ACCESS_REPORT, payload)
  }

  GetTemporalChangesReport(payload: IGetTemporalChangeReport) {
    return this.POST<ITemporalChangeReport>(this.PATHS.GET_TEMPORAL_CHANGE_REPORT, payload)
  }

  GetPostSummary(payload: IGetDashboardSummary) {
    return this.POST<IDashboardSummary>(this.PATHS.GET_POST_SUMMARY, payload)
  }

  GetSpentPointReport(payload: IGetDashboardSummary) {
    return this.POST<IDashboardSummary>(this.PATHS.GET_SPENT_POINT_REPORT, payload)
  }

  GetEngagementSummary(payload: IGetDashboardSummary) {
    return this.POST<IDashboardSummary>(this.PATHS.GET_ENGAGEMENT_SUMMARY, payload)
  }

  GetSignedInUsersReport(payload: IGetDashboardSummary) {
    return this.POST<IDashboardSummary>(this.PATHS.GET_SIGNED_IN_USERS_REPORT, payload)
  }

  GetEmployeesEarnPointSummary(payload: IGetDashboardSummary) {
    return this.POST<IDashboardSummary>(this.PATHS.GET_EMPLOYEES_EARN_POINT_SUMMARY, payload)
  }

  GetPortalLoginReportExcel(payload: IGetPortalLoginReport) {
    return this.EXCEL(this.PATHS.GET_PORTAL_LOGIN_REPORT_EXCEL, true, payload)
  }

  GetAccessReportExcel(payload: IDateRange) {
    return this.EXCEL(this.PATHS.GET_ACCESS_REPORT_EXCEL, true, payload)
  }

  GetTemporalChangeReportExcel(payload: IGetTemporalChangeReportExcel[]) {
    return this.EXCEL(this.PATHS.GET_TEMPORAL_CHANGE_REPORT_EXCEL, true, payload)
  }

  GetMobileSignedReport(payload: IGetMobileSignedInUsers) {
    return this.POST<IMobileSignedReport>(this.PATHS.GET_MOBILE_SIGNED_REPORT, payload)
  }
}
